import React from 'react'
import ResetModal from './ResetModal'
import EditModal from './EditModal'
import DeleteModal from './DeleteModal'
import { ACCOUNT_MODALS } from '../Account/account.constants'

const AccountModal = (modalName, setNotifyToggle) => {
	switch (modalName) {
		case ACCOUNT_MODALS.RESET_MODAL:
			return <ResetModal setNotifyToggle={setNotifyToggle} />
		case ACCOUNT_MODALS.EDIT_MODAL:
			return <EditModal setNotifyToggle={setNotifyToggle} />
		case ACCOUNT_MODALS.DELETE_MODAL:
			return <DeleteModal />

		default:
			return null
	}
}

export default AccountModal
